import { useState } from "react";
import { Layout, Drawer, Button } from "antd";
import { Link } from "react-router-dom";

import useMediaQueries from "../../../hooks/useMediaQueries";
import PreviewDevice from "./PreviewDevice";
import styles from "./styles.js";
import CompetitionsMenu from "../CompetitionsMenu";
import { MenuOutlined } from "@ant-design/icons";

const { Header } = Layout;

function PreviewPageHeader() {
  const { isSmallScreen } = useMediaQueries();

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const hideDrawer = () => {
    setOpen(false);
  };

  const onClose = () => {
    setOpen(false);
  };

  const flexGrow = isSmallScreen ? 1 : 0;

  return (
    <Header style={{ ...styles.container, padding: isSmallScreen ? 0 : null }}>
      {isSmallScreen ? (
        <div style={{ flexFlow: 0.5, paddingLeft: 15 }}>
          <Button
            onClick={showDrawer}
            type="text"
            icon={<MenuOutlined size={"large"} />}
          />
        </div>
      ) : null}

      <div style={{ ...styles.logoContainer, flexGrow }}>
        <Link to="/">
          <h1 style={{ fontSize: 20, color: "#91145b", fontWeight: "bold" }}>
            <span style={{ color: "#000", fontWeight: "normal" }}>
              Ondebrief.
            </span>
            Widgets
          </h1>
        </Link>
      </div>

      {!isSmallScreen ? (
        <div style={styles.previewDeviceContainer}>
          <PreviewDevice />
        </div>
      ) : null}

      <Drawer
        title="Competitions"
        width={"100%"}
        placement="left"
        onClose={onClose}
        open={open}
      >
        <CompetitionsMenu afterItemClick={hideDrawer} />
      </Drawer>

      {/* <div
        style={{
          flexGrow,
          ...styles.buyActionContainer,
        }}
      >
        <Button style={{ borderRadius: 20 }} size="large" type="primary">
          <span style={{ fontSize: "16px", marginInline: 10 }}>
            Get this Widget
          </span>
        </Button>
      </div> */}
    </Header>
  );
}

export default PreviewPageHeader;
